import React, { useState, useEffect } from "react";
import {  Form } from "react-bootstrap";
import Select, { components } from "react-select";

import authenticatedFetch from "../utils/fetch"

const MAX_VISIBLE_PRACTICES = 3;

const MultiValue = (props) => {
    const { index, getValue, selectProps } = props;

    if (index < MAX_VISIBLE_PRACTICES)
    {
        return <components.MultiValue {...props} />;
    }

    if (index === MAX_VISIBLE_PRACTICES)
    {
        return (
            <div style={{margin: "2px", padding: selectProps.compact ? "2px 6px" : "3px 6px", fontSize: selectProps.compact ? "0.75rem" : "85%", borderRadius: "2px", backgroundColor: "#DEF2F1"}}>
                {`+${getValue().length - MAX_VISIBLE_PRACTICES} more`}
            </div>
        );
    }

    return null;
};

const compactStyles = {
    control: (styles) => ({
        ...styles,
        minHeight: "30px",
        fontSize: "0.75rem",
    }),
    valueContainer: (styles) => ({
        ...styles,
        padding: "4px 6px",
    }),
    input: (styles) => ({
        ...styles,
        margin: "0px",
        padding: "0px",
    }),
    indicatorsContainer: (styles) => ({
        ...styles,
        height: "30px",
    }),
    dropdownIndicator: (styles) => ({
        ...styles,
        padding: "0 4px",
    }),
    clearIndicator: (styles) => ({
        ...styles,
        padding: "0 4px",
    }),
    option: (styles) => ({
        ...styles,
        fontSize: "0.75rem",
    }),
    menu: (styles) => ({
        ...styles,
        zIndex: 10,
    }),
};

const TaskPracticeSelect = ({ disabled, handlePracticesChanged, selectedPractices, compact=false, messagePrefix="Filter by"}) => {
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [data, setData] = useState([]);


    useEffect(() => {
        authenticatedFetch({
        path: "practice/availablepractices",
        successHandler: function(result) {
            setIsLoaded(true);
            setData(result);
        },
        errorHandler: function(error) {
            setIsLoaded(true);
            setError(error);
        }
        });
    }, [])

    if (!isLoaded)
    {
        return (<Form.Select disabled={true}><option value={0} key={0}>Loading...</option></Form.Select>);
    }
    else if (error || !data)
    {
        return (<Form.Select disabled={true}><option value={0} key={0}>Error... Please reload the page...</option></Form.Select>);
    }
    else
    {
        const compareCaseInsensitive = (a, b) => a.localeCompare(b, undefined, {sensitivity: "base"});

        const practiceOptions = [];
        const groupings = {};

        for (var i=0; i<data.length; i++)
        {
            const option = {value: data[i].id, label: data[i].name};
            practiceOptions.push(option);

            const rawGrouping = data[i].grouping && data[i].grouping.trim();
            if (rawGrouping)
            {
                const normalizedGrouping = rawGrouping.toUpperCase();
                if (!groupings[normalizedGrouping])
                {
                    groupings[normalizedGrouping] = {label: rawGrouping, practices: []};
                }
                groupings[normalizedGrouping].practices.push(option);
            }
        }

        practiceOptions.sort((a, b) => compareCaseInsensitive(a.label, b.label));

        const groupingOptions = Object.keys(groupings)
            .sort((a, b) => compareCaseInsensitive(groupings[a].label, groupings[b].label))
            .map((normalizedGrouping) => ({
                value: "grouping:" + normalizedGrouping,
                label: groupings[normalizedGrouping].label,
                isGrouping: true,
                practices: groupings[normalizedGrouping].practices.sort((a, b) => compareCaseInsensitive(a.label, b.label))
            }));

        const options = groupingOptions.length > 0
            ? [
                {label: "Regions", options: groupingOptions},
                {label: "Practices", options: practiceOptions}
              ]
            : practiceOptions;

        const onChange = (newValue, actionMeta) => {
            if (actionMeta.action === "select-option" && actionMeta.option && actionMeta.option.isGrouping)
            {
                const existingIds = new Set((selectedPractices || []).map((practice) => practice.value));
                const merged = [...(selectedPractices || [])];
                actionMeta.option.practices.forEach((practice) => {
                    if (!existingIds.has(practice.value))
                    {
                        existingIds.add(practice.value);
                        merged.push(practice);
                    }
                });
                handlePracticesChanged(merged);
                return;
            }

            handlePracticesChanged(newValue);
        };

        return (
        <Select
            options={options}
            isDisabled={disabled}
            onChange={onChange}
            value={selectedPractices}
            placeholder={groupingOptions.length > 0 ? `${messagePrefix} region or practice...` : `${messagePrefix} practice...`}
            isMulti
            compact={compact}
            components={{ MultiValue }}
            styles={compact ? compactStyles : undefined}
            theme={(theme) => ({
                ...theme,
                colors: {
                ...theme.colors,
                  primary50: '#DEF2F1',
                  primary25: '#DEF2F1',
                  primary: '#3AAFA9',
                },
              })}
        />
        )
    }
}

export default TaskPracticeSelect;